import { render, staticRenderFns } from "./NoteAddTechnical.vue?vue&type=template&id=13399231"
import script from "./NoteAddTechnical.vue?vue&type=script&lang=js"
export * from "./NoteAddTechnical.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports